<div class="col-12">
  <h1>Unauthorized</h1>
</div>
<div class="banner">
  <div class="row mt-3 pt-5 ms-3 pb-5">
    <div class="col-8">
      <div i18n>You are not authorized to view this page.
        <span *ngIf="showWrongCredentialsSdError && username">
          You have signed in as {{username}} with Carrier or Registrant credentials.
        </span>
        <span *ngIf="showWrongCredentialsSdError && !username">
          You appear to have signed in with Carrier or Registrant credentials.
        </span>
      </div>
      <div class='mt-3'>
        <button *ngIf="!showWrongCredentialsSdError" class="btn btn-primary" i18n (click)="back()">Back</button>
        <button *ngIf="showWrongCredentialsSdError" class="btn btn-primary" i18n (click)="logout()">Logout</button>
      </div>
    </div>
  </div>
</div>